module.exports = __webpack_public_path__ + "Roboto-RegularItalic.df8e3a9b9aed94341797.woff2";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-RegularItalic.woff2
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-RegularItalic.woff2
// module chunks = 5